import { create } from 'zustand';

interface UIStore {
  isMenuOpen: boolean;
  isPreloaderVisible: boolean;
  cursorType: 'default' | 'pointer' | 'text' | 'hover';
  setMenuOpen: (open: boolean) => void;
  toggleMenu: () => void;
  setPreloaderVisible: (visible: boolean) => void;
  setCursorType: (type: 'default' | 'pointer' | 'text' | 'hover') => void;
}

export const useUIStore = create<UIStore>((set) => ({
  isMenuOpen: false,
  isPreloaderVisible: true,
  cursorType: 'default',
  setMenuOpen: (open) => set({ isMenuOpen: open }),
  toggleMenu: () => set((state) => ({ isMenuOpen: !state.isMenuOpen })),
  setPreloaderVisible: (visible) => set({ isPreloaderVisible: visible }),
  setCursorType: (type) => set({ cursorType: type }),
}));

